import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ClientCompany } from 'common/types';

export interface State {
    client: ClientCompany | null;
}

export const initialState: State = {
    client: null,
};

export const clientCompanySlice = createSlice({
    name: 'clientCompany',
    initialState,
    reducers: {
        setClient(state, action: PayloadAction<ClientCompany | null>) {
            state.client = action.payload;
        },
    },
});

export const { setClient } = clientCompanySlice.actions;

export default clientCompanySlice.reducer;
